import { BNStack } from "@bn-monorepo/js-packages";
import { ReactNode } from "react";
import { StackProps, SvgIconProps } from "@mui/material";

export interface PublishElementInfoProps {
  Icon?: React.ComponentType<SvgIconProps>;
  label: string;
  value: ReactNode;
  valueLink?: string;
  sx?: StackProps["sx"];
}

export const PublishElementInfo: React.FC<PublishElementInfoProps> = ({ Icon, label, value, valueLink, sx }) => {
  return (
    <BNStack
      direction={"row"}
      sx={{
        gap: 1,
        whiteSpace: "nowrap",
        ...sx,
      }}
    >
      {Icon && <Icon />} {label}: {valueLink ? <a href={valueLink}>{value}</a> : value}
    </BNStack>
  );
};
